export default __webpack_public_path__ + "static/media/contact.13c80369.svg";